// extracted by mini-css-extract-plugin
export default {"spinner-container":"Spinner_spinner-container__cUIfm","spinner":"Spinner_spinner__rf06H","spin":"Spinner_spin__mnuz0"};